import React from "react";
import PhoneNumber from "libphonenumber-js";
import UtcToLocal from "../UtcToLocal";
import { formatCurrency } from "../../utils/valueFormatters";
import "../../Styles/receipt-download.scss";

function parseReceiptData(data) {
  if (typeof data === "string") {
    try {
      const parsed = JSON.parse(data);
      return Array.isArray(parsed) ? parsed : [parsed];
    } catch {
      return [];
    }
  }

  if (Array.isArray(data)) return data;
  if (data && typeof data === "object") return [data];
  return [];
}

function isCurrencyField(label) {
  return /amount|exchange rate/i.test(label);
}

function isDateField(label, value) {
  if (!/date|time/i.test(label)) return false;
  const parsedDate = Date.parse(value);
  return !Number.isNaN(parsedDate);
}

function normalizeReceiptValue(value) {
  if (value === null || value === undefined) return "";
  if (typeof value === "object") return JSON.stringify(value);
  return value;
}

function TransactionReceipt({ data, innerRef }) {
  const receiptRows = parseReceiptData(data);
  const receiptSections = receiptRows
    .filter((receipt) => receipt && typeof receipt === "object")
    .map((receipt, sectionIndex) => ({
      id: sectionIndex,
      rows: Object.keys(receipt)
        .map((key) => ({
          label: key,
          value: receipt[key],
        }))
        .filter(
          (row) =>
            row.value !== null && row.value !== undefined && row.value !== "",
        ),
    }))
    .filter((section) => section.rows.length > 0);

  const entityMobile = sessionStorage.getItem("EntityMobile");

  const parsedPhoneNumber =
    typeof entityMobile === "string" && entityMobile.trim()
      ? PhoneNumber(entityMobile, "LB")
      : null;

  const dateOptions = {
    day: "numeric",
    month: "short",
    weekday: "short",
    year: "numeric",
  };

  return (
    <div className="new-receipt-template container" ref={innerRef}>
      <div className="new-receipt-template__brand">
        <img src="/Images/suyool-with-logo.png" alt="Suyool" />
      </div>

      <div className="new-receipt-template__top row">
        <div className="col-6">
          <strong>{sessionStorage.getItem("EntityName")}</strong>
          <p>
            {parsedPhoneNumber?.isValid()
              ? parsedPhoneNumber.formatInternational()
              : ""}
          </p>
          <p>{sessionStorage.getItem("EntityAddress")}</p>
        </div>
        <div className="col-6 text-end">
          <strong>Transaction Receipt</strong>
          <p>Generated on {new Date().toLocaleDateString()}</p>
          <p>Suyool SAL</p>
        </div>
      </div>

      <div className="new-receipt-template__details">
        <h2>Transaction Details</h2>
        {receiptSections.map((section, sectionIndex) => (
          <div className="new-receipt-template__section" key={section.id}>
            {receiptSections.length > 1 ? (
              <h3>Receipt Item {sectionIndex + 1}</h3>
            ) : null}

            {section.rows.map((item) => (
              <div
                className="new-receipt-template__row"
                key={`${section.id}-${item.label}`}
              >
                <span>{item.label}</span>
                <strong>
                  {isDateField(item.label, item.value) ? (
                    <UtcToLocal
                      utcTimestamp={item.value}
                      options={dateOptions}
                    />
                  ) : isCurrencyField(item.label) ? (
                    formatCurrency(item.value)
                  ) : (
                    normalizeReceiptValue(item.value)
                  )}
                </strong>
              </div>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}

export default TransactionReceipt;
